import { render } from "./EditorTry.vue?vue&type=template&id=45c1cb8c&scoped=true"
import script from "./EditorTry.vue?vue&type=script&lang=js"
export * from "./EditorTry.vue?vue&type=script&lang=js"

import "./EditorTry.vue?vue&type=style&index=0&id=45c1cb8c&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c1cb8c"]])

export default __exports__